import React from "react"
import autobind from "class-autobind"
import { Drawer, Tabs, Tab } from "material-ui"
import { amber50, amber200 } from "material-ui/styles/colors"
import moment from "moment"
import { IDateRange, IObjectTimecardDocument } from "../../../models"
import strings from "../../../localization/strings"
import EmployeeWorkHistoryDrawerContent from "./EmployeeWorkHistoryDrawerContent"
import EquipmentWorkHistoryDrawerContent from "./EquipmentWorkHistoryDrawerContent"
import NoteDrawerContent from "./NoteDrawerContent"
import AppStateStore from "../../../stores/AppStateStore"
import BreadCrumbDrawerContent from "./BreadCrumbDrawerContent"
interface IProps {
    byEmployee?: boolean
    open: boolean
    dayNum: number
    imageS3Url: string
    timecard: IObjectTimecardDocument
    objectTimecardId: string
    userId: string
    timecardDates: IDateRange
    enableBreadcrumb: boolean
    closeDailyDrawer(): void
}
interface IState {
    selectedTab: string
    dayNum: number
    headerLeftIconMouseOver: boolean
    headerRightIconMouseOver: boolean
    headerCloseIconMouseOver: boolean
}

export default class TimecardDailyDrawerContent extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedTab: props.byEmployee ? "notes" : "work_history",
            dayNum: props.dayNum,
            headerLeftIconMouseOver: false,
            headerRightIconMouseOver: false,
            headerCloseIconMouseOver: false
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps) {
        nextProps.open &&
            this.setState({ dayNum: nextProps.dayNum })
    }

    handleHeaderIconMouseOver(identity) {
        switch (identity) {
            case "Left":
                this.setState({ headerLeftIconMouseOver: true })
                break
            case "Right":
                this.setState({ headerRightIconMouseOver: true })
                break
            case "Close":
                this.setState({ headerCloseIconMouseOver: true })
                break
        }
    }

    handleHeaderIconMouseOut(identity) {
        switch (identity) {
            case "Left":
                this.setState({ headerLeftIconMouseOver: false })
                break
            case "Right":
                this.setState({ headerRightIconMouseOver: false })
                break
            case "Close":
                this.setState({ headerCloseIconMouseOver: false })
                break
        }
    }

    render() {
        const { dayNum, headerLeftIconMouseOver, headerRightIconMouseOver, headerCloseIconMouseOver } = this.state
        const dayData = this.props.timecard.MasterTimecard.TimecardWeeks[0].Days[dayNum]
        return (
            <Drawer
                open={this.props.open}
                openSecondary
                width={1000}
                style={{ maxWidth: 1000 }}
                docked={false}
                overlayStyle={{ zIndex: 1500 }}
                containerStyle={{
                    zIndex: 1500,
                    opacity: this.props.open ? 1 : 0,
                    transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
                }}
                onRequestChange={this.props.closeDailyDrawer}
            >
                <div style={{ backgroundColor: AppStateStore.getDrawerHeaderColor(), height: 58, padding: 16, position: "relative", textAlign: "center" }}>
                    {dayNum !== 0 &&
                        <i
                            className="fa fa-arrow-circle-o-left"
                            style={{
                                color: headerLeftIconMouseOver ? amber200 : amber50,
                                fontSize: 30,
                                position: "absolute",
                                top: 30,
                                left: 100,
                                cursor: "pointer"
                            }}
                            onMouseOver={this.handleHeaderIconMouseOver.bind(this, "Left")}
                            onMouseOut={this.handleHeaderIconMouseOut.bind(this, "Left")}
                            onClick={() =>
                                this.setState(prev =>({...prev,
                                    dayNum: prev.dayNum - 1,
                                    headerRightIconMouseOver: false
                                }))
                            }
                        />
                    }
                    <div>
                        <div style={{ color: amber50, fontWeight: 700, fontSize: 30, marginTop: 10 }}>
                            {moment(dayData.LocalStartDayTime).utc().format("dddd").toUpperCase()}
                        </div>
                        <div style={{ color: amber50, fontSize: 18, fontWeight: 600, marginTop: 5 }}>
                            {moment(dayData.LocalStartDayTime).utc().format("MMMM DD").toUpperCase()}
                        </div>
                    </div>
                    {dayNum !== 6 &&
                        <i
                            className="fa fa-arrow-circle-o-right"
                            style={{
                                color: headerRightIconMouseOver ? amber200 : amber50,
                                fontSize: 30,
                                position: "absolute",
                                top: 30,
                                right: 100,
                                cursor: "pointer"
                            }}
                            onMouseOver={this.handleHeaderIconMouseOver.bind(this, "Right")}
                            onMouseOut={this.handleHeaderIconMouseOut.bind(this, "Right")}
                            onClick={() =>
                                this.setState(prev =>({...prev,
                                    dayNum: prev.dayNum + 1,
                                    headerLeftIconMouseOver: false
                                }))
                            }
                        />
                    }
                    <i
                        className="fa fa-close"
                        style={{
                            color: headerCloseIconMouseOver ? amber200 : amber50,
                            fontSize: 25,
                            position: "absolute",
                            top: 30,
                            right: 30,
                            cursor: "pointer"
                        }}
                        onClick={this.props.closeDailyDrawer}
                        onMouseOver={this.handleHeaderIconMouseOver.bind(this, "Close")}
                        onMouseOut={this.handleHeaderIconMouseOut.bind(this, "Close")}
                    />
                </div>
                <Tabs
                    value={this.state.selectedTab}
                    onChange={selectedTab => this.setState({ selectedTab })}
                >
                    {this.props.byEmployee &&
                        <Tab label={strings.Notes} value="notes">
                            {this.state.selectedTab === "notes" &&
                                <NoteDrawerContent
                                    timecardNoteObjectData={{
                                        ObjectId: this.props.objectTimecardId,
                                        TimecardRef: {
                                            UserId: this.props.userId,
                                            StartDate: this.props.timecardDates.StartDate,
                                            Timecard: this.props.timecard,
                                        }
                                    }}
                                    timecardDates={this.props.timecardDates}
                                    dayData={dayData}
                                    dataType="timecard"
                                />
                            }
                        </Tab>
                    }
                    <Tab label={strings.Work_History} value="work_history">
                        {this.state.selectedTab === "work_history" && (
                            this.props.byEmployee ?
                                <EmployeeWorkHistoryDrawerContent
                                    dayNum={this.state.dayNum}
                                    timecard={this.props.timecard}
                                    imageS3Url={this.props.imageS3Url}
                                    key={this.state.dayNum}
                                /> :
                                <EquipmentWorkHistoryDrawerContent
                                    dayNum={this.props.dayNum}
                                    timecard={this.props.timecard.MasterTimecard}
                                    imageS3Url={this.props.imageS3Url}
                                    dayData={dayData}
                                />
                        )
                        }
                    </Tab>
                    {this.props.enableBreadcrumb &&
                        <Tab label={strings.Breadcrumb} value="breadcrumb">
                            {this.state.selectedTab === "breadcrumb" &&
                                <BreadCrumbDrawerContent
                                    objectId={this.props.userId}
                                    dayData={dayData}
                                />
                            }
                        </Tab>
                    }
                </Tabs>
            </Drawer>
        )
    }
}
